import React from 'react';
import { motion } from 'framer-motion';
import { hero } from '../data/homepage';
import { HeroAtna } from './HeroAtna';

/** Trace du coeur, dans un viewBox 0-100. */
export const COEUR_PATH = 'M50,100 C50,100 0,68 0,32 C0,12 15,0 29,0 C40,0 47,6 50,13 C53,6 60,0 71,0 C85,0 100,12 100,32 C100,68 50,100 50,100 Z';

/** Meme trace, normalise, pour le <clipPath> qui masque les photos. */
export const COEUR_PATH_UNIT = 'M0.5,1 C0.5,1 0,0.68 0,0.32 C0,0.12 0.15,0 0.29,0 C0.4,0 0.47,0.06 0.5,0.13 C0.53,0.06 0.6,0 0.71,0 C0.85,0 1,0.12 1,0.32 C1,0.68 0.5,1 0.5,1 Z';
function Coeur({
  className,
  fill,
  opacity = 1
}: {
  className: string;
  fill: string;
  opacity?: number;
}) {
  return <svg viewBox="0 0 100 100" aria-hidden="true" className={className} style={{
    opacity
  }} data-id="element-1444" data-mp="1uipocd63j99u">
      <path d={COEUR_PATH} fill={fill} data-id="element-1445" data-mp="39z82c6s3a37r" />
    </svg>;
}
export function Hero() {
  return <section aria-label="Ville de Windsor" className="relative w-full overflow-hidden bg-ville-mist" data-id="element-1446" data-mp="35xmrss31210q">
      <img src={hero.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-1447" data-mp="3bhf6qjb2g78u" />
      <span className="absolute inset-0 bg-ville-navy/10" aria-hidden="true" data-id="element-1448" data-mp="3ggi1naxc0x33" />

      <Coeur className="pointer-events-none absolute -left-[12%] -top-[18%] h-[150%] w-auto sm:-left-[6%]" fill="#e9554a" data-id="element-1449" data-mp="3gimfakl19agk" />
      <Coeur className="pointer-events-none absolute -top-[10%] left-[18%] hidden h-[130%] w-auto lg:block" fill="#c6ecd6" opacity={0.55} data-id="element-1450" data-mp="3phpwfj0n3fsf" />

      <div className="relative mx-auto grid min-h-[420px] max-w-[1500px] items-center gap-10 px-5 py-16 lg:min-h-[560px] lg:grid-cols-[1fr_minmax(0,480px)] lg:gap-14 lg:px-10 lg:pb-28" data-id="element-1451" data-mp="2wsippwr17jw3">
        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-script text-6xl leading-none text-white drop-shadow-[0_2px_10px_rgba(13,79,70,0.35)] sm:text-7xl lg:text-8xl" data-id="element-1452" data-mp="31pizahn3b4ry">
          {hero.script}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1453" data-mp="3hbx2a19ustvm">
          <HeroAtna data-id="element-1454" data-mp="3q47bbf90itba" />
        </motion.div>
      </div>
    </section>;
}